<div
  class="flex items-center gap-2 border-x-0 border-b border-t-0 border-solid border-pill px-6 py-2.5"
>
  <div class="flex min-w-0 flex-auto items-center gap-2">
    <!-- role="heading", not <h4>: Material's `.mat-typography h4` sets the font shorthand at
         (0,1,1) and silently beats the single-class utilities. -->
    <div role="heading" aria-level="4" class="text-base font-semibold text-theme-black">
      {{ header | translate }}
    </div>
    <span class="walkme-anchor" [attr.walkme-anchor]="header"></span>
    <span
      *ngIf="tooltipText"
      class="text-gray-500"
      matTooltip="{{ tooltipText }}"
      matTooltipPosition="right"
      matTooltipClass="tl-common-form-tooltip"
    >
      <i class="fa-solid fa-info-circle"></i>
    </span>
  </div>
  <!-- text-gray-500 is inherited by the Reset mat-button, whose own colour is `inherit`. -->
  <div *ngIf="showActionControls" class="flex items-center gap-2 text-gray-500">
    <button
      mat-button
      (click)="onResetClicked()"
      siteUsageTracker
      [logCategory]="'TankSetup'"
      [logName]="'ResetForm'"
      [disabled]="resetDisabled"
    >
      {{ 'General.Reset' | translate }}
    </button>
    <button
      *ngIf="showSaveButton"
      mat-raised-button
      class="add-new-item-button"
      (click)="onSaveClicked()"
      siteUsageTracker
      [logCategory]="'TankSetup'"
      [logName]="'SaveChanges'"
      [disabled]="saveDisabled"
    >
      <mat-icon>check</mat-icon>{{ saveButtonText | translate }}
    </button>
  </div>
  <!-- Optional custom action buttons projected by the host form. Renders nothing when no
       [form-actions] content is provided, so existing forms are unaffected. -->
  <span class="custom-form-actions">
    <ng-content select="[form-actions]"></ng-content>
  </span>
</div>
<!-- flushContent: for a card whose content is edge-to-edge (a map), the body drops its padding
     and the host clips, so the content follows the card radius. -->
<div class="form-controls-panel" [ngClass]="flushContent ? '' : 'p-6'">
  <ng-content select="[form-content]"> </ng-content>
</div>
